import { render, staticRenderFns } from "./RestaurantsSettings.vue?vue&type=template&id=44f20134&scoped=true"
import script from "./RestaurantsSettings.vue?vue&type=script&lang=js"
export * from "./RestaurantsSettings.vue?vue&type=script&lang=js"
import style0 from "./RestaurantsSettings.vue?vue&type=style&index=0&id=44f20134&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f20134",
  null
  
)

export default component.exports